/* L'Innovateur The Parfum — theme.js (vanilla, no dependencies) */
document.documentElement.classList.remove('no-js');

(function () {
  'use strict';

  /* ---------------------------------------------------------------------
     Mobile navigation
  --------------------------------------------------------------------- */
  var navToggle = document.querySelector('[data-nav-toggle]');
  var mobileNav = document.querySelector('[data-mobile-nav]');

  function openMobileNav() {
    if (mobileNav) { mobileNav.classList.add('is-open'); document.body.style.overflow = 'hidden'; }
  }
  function closeMobileNav() {
    if (mobileNav) { mobileNav.classList.remove('is-open'); document.body.style.overflow = ''; }
  }
  if (navToggle) navToggle.addEventListener('click', openMobileNav);
  document.querySelectorAll('[data-mobile-nav-close]').forEach(function (el) {
    el.addEventListener('click', closeMobileNav);
  });

  /* ---------------------------------------------------------------------
     Product tabs (Mujer / Hombre / Todos)
  --------------------------------------------------------------------- */
  document.querySelectorAll('[data-product-tabs]').forEach(function (wrap) {
    var buttons = wrap.querySelectorAll('[data-tab-target]');
    buttons.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var target = btn.getAttribute('data-tab-target');
        buttons.forEach(function (b) { b.classList.remove('is-active'); });
        btn.classList.add('is-active');
        wrap.querySelectorAll('[data-tab-panel]').forEach(function (panel) {
          panel.classList.toggle('is-active', panel.getAttribute('data-tab-panel') === target);
        });
      });
    });
  });

  /* ---------------------------------------------------------------------
     Cart drawer + AJAX cart (Shopify Ajax API)
  --------------------------------------------------------------------- */
  var cartDrawer = document.getElementById('CartDrawer');
  var cartBody = document.getElementById('CartDrawerBody');
  var cartFooter = document.getElementById('CartDrawerFooter');

  function openCartDrawer() {
    if (!cartDrawer) return;
    cartDrawer.classList.add('is-open');
    cartDrawer.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    renderCartDrawer();
  }
  function closeCartDrawer() {
    if (!cartDrawer) return;
    cartDrawer.classList.remove('is-open');
    cartDrawer.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }
  document.querySelectorAll('[data-cart-drawer-open]').forEach(function (el) {
    el.addEventListener('click', function (e) { e.preventDefault(); openCartDrawer(); });
  });
  document.querySelectorAll('[data-cart-drawer-close]').forEach(function (el) {
    el.addEventListener('click', closeCartDrawer);
  });

  function money(cents) {
    return '$' + (cents / 100).toFixed(2);
  }

  function renderCartDrawer() {
    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        updateCartCount(cart.item_count);

        if (!cart.items.length) {
          cartBody.innerHTML = '<div class="cart-empty"><p>Tu carrito está vacío.</p><a class="btn btn--dark" href="/collections/all">Ver perfumes</a></div>';
          cartFooter.innerHTML = '';
          return;
        }

        var linesHtml = cart.items.map(function (item) {
          return (
            '<div class="cart-line" data-line-key="' + item.key + '">' +
              '<img src="' + (item.image ? item.image.replace(/(\.[a-zA-Z]{3,4})(\?.*)?$/, '_160x$1$2') : '') + '" alt="' + item.product_title + '">' +
              '<div style="flex:1">' +
                '<div class="cart-line__title">' + item.product_title + '</div>' +
                '<div class="cart-line__variant">' + (item.variant_title || '') + '</div>' +
                '<div style="display:flex;align-items:center;justify-content:space-between;">' +
                  '<span class="cart-line__qty">' +
                    '<button type="button" data-qty-minus>&minus;</button>' +
                    '<span style="padding:0 8px;font-size:13px;">' + item.quantity + '</span>' +
                    '<button type="button" data-qty-plus>&plus;</button>' +
                  '</span>' +
                  '<strong style="font-size:13px;">' + money(item.final_line_price) + '</strong>' +
                '</div>' +
                '<button type="button" class="cart-line__remove" data-line-remove>Eliminar</button>' +
              '</div>' +
            '</div>'
          );
        }).join('');

        cartBody.innerHTML = linesHtml;

        cartFooter.innerHTML =
          '<div class="cart-subtotal"><span>Subtotal</span><span>' + money(cart.total_price) + '</span></div>' +
          '<p style="font-size:12px;color:#8b8378;margin-bottom:14px;">Impuestos y envío calculados en el checkout.</p>' +
          '<a href="/checkout" class="btn btn--primary btn--full">Finalizar compra</a>' +
          '<a href="/cart" class="btn btn--outline btn--full" style="margin-top:10px;">Ver carrito</a>';

        cartBody.querySelectorAll('[data-line-key]').forEach(function (line) {
          var key = line.getAttribute('data-line-key');
          var plus = line.querySelector('[data-qty-plus]');
          var minus = line.querySelector('[data-qty-minus]');
          var remove = line.querySelector('[data-line-remove]');
          if (plus) plus.addEventListener('click', function () { changeLine(key, 1); });
          if (minus) minus.addEventListener('click', function () { changeLine(key, -1); });
          if (remove) remove.addEventListener('click', function () { setLine(key, 0); });
        });
      });
  }

  function changeLine(key, delta) {
    fetch('/cart.js').then(function (r) { return r.json(); }).then(function (cart) {
      var item = cart.items.find(function (i) { return i.key === key; });
      if (!item) return;
      setLine(key, Math.max(0, item.quantity + delta));
    });
  }

  function setLine(key, quantity) {
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity })
    })
      .then(function (r) { return r.json(); })
      .then(function () { renderCartDrawer(); });
  }

  function updateCartCount(count) {
    document.querySelectorAll('[data-cart-count]').forEach(function (el) {
      el.textContent = count;
      el.classList.toggle('hidden', count === 0);
    });
  }

  // initial count on load
  fetch('/cart.js').then(function (r) { return r.json(); }).then(function (cart) {
    updateCartCount(cart.item_count);
  });

  /* ---------------------------------------------------------------------
     Add to cart forms (product card quick-add + product page form)
  --------------------------------------------------------------------- */
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('[data-add-to-cart-form]');
    if (!form) return;
    e.preventDefault();

    // "Comprar ahora" adds the item then sends the visitor straight to checkout
    // instead of opening the cart drawer, like the regular "Agregar al carrito".
    var isBuyNow = e.submitter ? e.submitter.hasAttribute('data-buy-now') : false;
    var submitBtn = isBuyNow ? e.submitter : form.querySelector('[type="submit"]');
    var originalText = submitBtn ? submitBtn.textContent : '';
    if (submitBtn) { submitBtn.textContent = isBuyNow ? 'Procesando...' : 'Agregando...'; submitBtn.disabled = true; }

    var formData = new FormData(form);

    fetch('/cart/add.js', { method: 'POST', body: formData, headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function () {
        if (isBuyNow) {
          window.location.href = '/checkout';
          return;
        }
        if (submitBtn) { submitBtn.textContent = originalText; submitBtn.disabled = false; }
        openCartDrawer();
      })
      .catch(function () {
        if (submitBtn) { submitBtn.textContent = originalText; submitBtn.disabled = false; }
      });
  });

  /* ---------------------------------------------------------------------
     Product page: gallery thumbs, quantity input, sticky ATC
  --------------------------------------------------------------------- */
  document.querySelectorAll('[data-gallery]').forEach(function (gallery) {
    var mainImg = gallery.querySelector('[data-gallery-main]');
    gallery.querySelectorAll('[data-gallery-thumb]').forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        if (mainImg) mainImg.src = thumb.getAttribute('data-full') || thumb.src;
        gallery.querySelectorAll('[data-gallery-thumb]').forEach(function (t) { t.classList.remove('is-active'); });
        thumb.classList.add('is-active');
      });
    });
  });

  document.querySelectorAll('[data-qty-input-wrap]').forEach(function (wrap) {
    var input = wrap.querySelector('input');
    var plus = wrap.querySelector('[data-qty-plus]');
    var minus = wrap.querySelector('[data-qty-minus]');
    if (plus) plus.addEventListener('click', function () { input.value = Math.max(1, (parseInt(input.value, 10) || 1) + 1); });
    if (minus) minus.addEventListener('click', function () { input.value = Math.max(1, (parseInt(input.value, 10) || 1) - 1); });
  });

  var stickyAtc = document.querySelector('[data-sticky-atc]');
  var mainAtc = document.querySelector('[data-main-add-to-cart]');
  if (stickyAtc && mainAtc) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        stickyAtc.classList.toggle('is-visible', !entry.isIntersecting);
      });
    }, { threshold: 0 });
    io.observe(mainAtc);

    var stickyBtn = stickyAtc.querySelector('[data-sticky-atc-submit]');
    if (stickyBtn) {
      stickyBtn.addEventListener('click', function () {
        var form = document.querySelector('[data-add-to-cart-form]');
        if (form) form.requestSubmit ? form.requestSubmit() : form.dispatchEvent(new Event('submit', { cancelable: true }));
      });
    }
  }

  /* ---------------------------------------------------------------------
     Variant selection: swap hidden variant id + displayed price
  --------------------------------------------------------------------- */
  document.querySelectorAll('[data-product-json]').forEach(function (script) {
    var variants;
    try { variants = JSON.parse(script.textContent); } catch (e) { return; }

    var form = script.closest('.product-info') ? script.closest('.container').querySelector('[data-add-to-cart-form]') : null;
    if (!form) form = document.querySelector('[data-add-to-cart-form]');
    var idInput = form ? form.querySelector('[data-variant-id-input]') : null;
    var priceEl = document.querySelector('.product-info__price');
    var stickyPriceEl = document.querySelector('.sticky-atc__price');
    var optionInputs = form ? form.querySelectorAll('[data-option-position]') : [];

    function money(cents) { return '$' + (cents / 100).toFixed(2); }

    function currentSelectedOptions() {
      var selected = [];
      optionInputs.forEach(function (input) {
        if (input.checked) selected[parseInt(input.getAttribute('data-option-position'), 10) - 1] = input.value;
      });
      return selected;
    }

    function findMatchingVariant() {
      var selected = currentSelectedOptions();
      return variants.find(function (v) {
        var opts = [v.option1, v.option2, v.option3].filter(function (o) { return o !== null; });
        return opts.every(function (o, i) { return !selected[i] || selected[i] === o; });
      });
    }

    function applyVariant(variant) {
      if (!variant) return;
      if (idInput) idInput.value = variant.id;
      var priceHtml = money(variant.price);
      if (variant.compare_at_price && variant.compare_at_price > variant.price) {
        priceHtml = '<s>' + money(variant.compare_at_price) + '</s>' + priceHtml;
      }
      if (priceEl) priceEl.innerHTML = priceHtml;
      if (stickyPriceEl) stickyPriceEl.textContent = money(variant.price);

      var submitBtn = form.querySelector('[type="submit"]');
      if (submitBtn) {
        submitBtn.disabled = !variant.available;
        submitBtn.textContent = variant.available ? 'Agregar al carrito' : 'Agotado';
      }
    }

    optionInputs.forEach(function (input) {
      input.addEventListener('change', function () { applyVariant(findMatchingVariant()); });
    });
  });

  /* ---------------------------------------------------------------------
     Manual carousels (Recién llegados / También te puede gustar / Vistos
     recientemente). No autoplay — the visitor moves it with the arrows or
     by swiping/dragging the track directly.
  --------------------------------------------------------------------- */
  function initCarousel(wrap) {
    var track = wrap.querySelector('[data-carousel-track], [data-recently-viewed-track]');
    if (!track) return;
    var prevBtn = wrap.querySelector('[data-carousel-prev]');
    var nextBtn = wrap.querySelector('[data-carousel-next]');

    function cardWidth() {
      var card = track.querySelector('.product-card');
      return card ? card.getBoundingClientRect().width + 20 : 260;
    }
    function updateNav() {
      if (prevBtn) prevBtn.disabled = track.scrollLeft <= 4;
      if (nextBtn) nextBtn.disabled = track.scrollLeft >= track.scrollWidth - track.clientWidth - 4;
    }
    if (prevBtn) prevBtn.addEventListener('click', function () {
      track.scrollBy({ left: -cardWidth() * 2, behavior: 'smooth' });
    });
    if (nextBtn) nextBtn.addEventListener('click', function () {
      track.scrollBy({ left: cardWidth() * 2, behavior: 'smooth' });
    });
    track.addEventListener('scroll', function () {
      clearTimeout(track._navTimeout);
      track._navTimeout = setTimeout(updateNav, 80);
    }, { passive: true });
    updateNav();
  }
  document.querySelectorAll('[data-carousel-nav]').forEach(function (nav) {
    if (nav.closest('[data-recently-viewed]')) return; // initialized after its content loads, below
    initCarousel(nav.closest('.container') || nav.parentElement);
  });

  /* ---------------------------------------------------------------------
     Recently viewed products (rendered from localStorage, no extra requests)
  --------------------------------------------------------------------- */
  document.querySelectorAll('[data-recently-viewed]').forEach(function (section) {
    var track = section.querySelector('[data-recently-viewed-track]');
    if (!track) return;
    var currentUrl = window.location.pathname;
    var list;
    try { list = JSON.parse(localStorage.getItem('linnovateur_recently_viewed') || '[]'); } catch (e) { list = []; }
    list = list.filter(function (p) { return p.url !== currentUrl; });

    if (!list.length) return;

    track.innerHTML = list.map(function (p) {
      return (
        '<div class="product-card">' +
          '<a href="' + p.url + '" class="product-card__media-link">' +
            '<div class="product-card__media"><img src="' + p.image + '" alt="' + (p.title || '') + '" loading="lazy"></div>' +
          '</a>' +
          '<a href="' + p.url + '">' +
            '<span class="product-card__vendor">' + (p.vendor || '') + '</span>' +
            '<h3 class="product-card__title">' + p.title + '</h3>' +
            '<div class="product-card__price">' + p.price + '</div>' +
          '</a>' +
        '</div>'
      );
    }).join('');

    section.classList.add('has-items');
    var navWrap = section.querySelector('[data-carousel-nav]');
    if (navWrap) initCarousel(navWrap.closest('.container'));
  });

  /* ---------------------------------------------------------------------
     Collection filters: checkbox / price form auto-submits (native
     Shopify Storefront Filtering, no extra app required)
  --------------------------------------------------------------------- */
  var filtersPanel = document.querySelector('[data-filters]');
  if (filtersPanel) {
    var filtersForm = filtersPanel.querySelector('form');
    filtersPanel.querySelectorAll('input[type="checkbox"]').forEach(function (input) {
      input.addEventListener('change', function () { filtersForm.submit(); });
    });
    var filtersToggle = document.querySelector('[data-filters-toggle]');
    var filtersClose = filtersPanel.querySelector('[data-filters-close]');
    if (filtersToggle) filtersToggle.addEventListener('click', function () { filtersPanel.classList.add('is-open'); });
    if (filtersClose) filtersClose.addEventListener('click', function () { filtersPanel.classList.remove('is-open'); });
  }

  /* ---------------------------------------------------------------------
     Catalog search flyout — searches locally over every product's title,
     L'Innovateur name, inspiration perfume, reference brand and vendor, plus
     gender/category filter chips. Runs entirely client-side against the
     JSON index rendered in theme.liquid, so it finds matches inside
     metafields that Shopify's own /search/suggest.json endpoint can't see.
  --------------------------------------------------------------------- */
  var searchFlyout = document.getElementById('SearchFlyout');
  if (searchFlyout) {
    var searchInput = searchFlyout.querySelector('[data-search-input]');
    var searchResults = searchFlyout.querySelector('[data-search-results]');
    var filtersWrap = searchFlyout.querySelector('[data-search-filters]');
    var searchTimer;
    var activeGender = null;
    var activeCategory = null;

    var catalog = [];
    var indexEl = document.getElementById('CatalogSearchIndex');
    if (indexEl) {
      try { catalog = JSON.parse(indexEl.textContent); } catch (e) { catalog = []; }
    }

    function normalizeSearch(value) { return String(value).normalize('NFD').replace(/[\u0300-\u036f]/g, '').trim().toLowerCase(); }
    // Reference classification only; Shopify metafields always take precedence.
    var referenceClasses = {
      'sauvage-parfum': {gender:'hombre',category:'diseñador',reference_brand:'Dior'},
      'my-slf': {gender:'hombre',category:'diseñador',reference_brand:'Yves Saint Laurent'},
      'queen-of-silk': {gender:'mujer',category:'nicho',reference_brand:'Creed'},
      'original-santal': {gender:'unisex',category:'nicho',reference_brand:'Creed'},
      'santal-33': {category:'nicho',reference_brand:'Le Labo'},
      'afternoon-swim': {category:'diseñador',reference_brand:'Louis Vuitton'},
      'symphony': {category:'diseñador',reference_brand:'Louis Vuitton'}
    };
    catalog.forEach(function(p) {
      var fallback = referenceClasses[p.handle] || {};
      ['gender','category','reference_brand'].forEach(function(key) { p[key] = p[key] || fallback[key] || ''; });
    });
    searchFlyout.querySelector('form').addEventListener('submit', function(event) { event.preventDefault(); renderResults(); });
    var resetFilters = document.createElement('button');
    resetFilters.type = 'button'; resetFilters.className = 'search-filter-chip'; resetFilters.textContent = 'Todos';
    resetFilters.addEventListener('click', function() {
      activeGender = null; activeCategory = null;
      filtersWrap.querySelectorAll('.is-active').forEach(function(chip) { chip.classList.remove('is-active'); });
      renderResults();
    });
    if (filtersWrap) filtersWrap.prepend(resetFilters);
    if (filtersWrap) filtersWrap.querySelectorAll('[data-filter-gender],[data-filter-category]').forEach(function(chip) {
      var key = chip.hasAttribute('data-filter-gender') ? 'gender' : 'category';
      var value = chip.getAttribute('data-filter-' + key);
      chip.disabled = !catalog.some(function(p) { return normalizeSearch(p[key]) === normalizeSearch(value); });
      if (chip.disabled) chip.title = 'Clasificación pendiente en el catálogo';
    });

    function escapeHtml(str) {
      return (str || '').replace(/[&<>"']/g, function (c) {
        return ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' })[c];
      });
    }

    function openSearchFlyout() {
      renderResults();
      searchFlyout.classList.add('is-open');
      document.body.style.overflow = 'hidden';
      setTimeout(function () { if (searchInput) searchInput.focus(); }, 50);
    }
    function closeSearchFlyout() {
      searchFlyout.classList.remove('is-open');
      document.body.style.overflow = '';
    }
    document.querySelectorAll('[data-search-open]').forEach(function (el) {
      el.addEventListener('click', function (e) { e.preventDefault(); openSearchFlyout(); });
    });
    searchFlyout.querySelectorAll('[data-search-close]').forEach(function (el) {
      el.addEventListener('click', closeSearchFlyout);
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closeSearchFlyout();
    });

    function renderResults() {
      var term = normalizeSearch(searchInput.value || '');


      var matches = catalog.filter(function (p) {
        if (activeGender && normalizeSearch(p.gender) !== normalizeSearch(activeGender)) return false;
        if (activeCategory && normalizeSearch(p.category) !== normalizeSearch(activeCategory)) return false;
        if (!term) return true;
        var haystack = normalizeSearch([p.title, p.inspired_by, p.reference_brand, p.vendor].join(' '));
        return haystack.indexOf(term) !== -1;
      });

      if (!matches.length) {
        searchResults.innerHTML = '<p class="search-flyout__empty">' +
          (term ? 'Sin resultados para "' + escapeHtml(searchInput.value.trim()) + '".' : 'Sin resultados con estos filtros.') +
          '</p>';
        return;
      }

      searchResults.innerHTML = matches.map(function (p) {
        var inspiredLine = '';
        if (p.inspired_by) {
          inspiredLine = '<span class="result-inspired">Inspirado en ' + escapeHtml(p.inspired_by) +
            (p.reference_brand ? ' de ' + escapeHtml(p.reference_brand) : '') + '</span>';
        }
        var priceLine = (p.variants || []).map(function (v) {
          return escapeHtml(v.title) + ' — ' + escapeHtml(v.price);
        }).join(' · ');

        return (
          '<a href="' + p.url + '">' +
            '<img src="' + (p.image || '') + '" alt="">' +
            '<span>' +
              '<strong>' + escapeHtml(p.title) + '</strong>' +
              inspiredLine +
              (priceLine ? '<span class="result-prices">' + priceLine + '</span>' : '') +
            '</span>' +
          '</a>'
        );
      }).join('');
    }

    if (filtersWrap) {
      filtersWrap.querySelectorAll('[data-filter-gender]').forEach(function (chip) {
        chip.addEventListener('click', function () {
          var val = chip.getAttribute('data-filter-gender');
          activeGender = activeGender === val ? null : val;
          filtersWrap.querySelectorAll('[data-filter-gender]').forEach(function (c) {
            c.classList.toggle('is-active', c === chip && activeGender !== null);
          });
          renderResults();
        });
      });
      filtersWrap.querySelectorAll('[data-filter-category]').forEach(function (chip) {
        chip.addEventListener('click', function () {
          var val = chip.getAttribute('data-filter-category');
          activeCategory = activeCategory === val ? null : val;
          filtersWrap.querySelectorAll('[data-filter-category]').forEach(function (c) {
            c.classList.toggle('is-active', c === chip && activeCategory !== null);
          });
          renderResults();
        });
      });
    }

    if (searchInput) {
      searchInput.addEventListener('input', function () {
        clearTimeout(searchTimer);
        searchTimer = setTimeout(renderResults, 150);
      });
    }
  }
})();

/* Shared disclosure navigation. */
document.querySelectorAll(".design-mobile-menu").forEach(function(menu){ menu.querySelectorAll("a").forEach(function(link){link.addEventListener("click",function(){menu.open=false;});}); document.addEventListener("keydown",function(event){if(event.key === "Escape" && menu.open){menu.open=false;menu.querySelector("summary").focus();}});});
